// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"oZ","hidden":"o0"};